import { createStore } from 'owa-satcheljs';
import type { ConfirmationDialogStoreState } from './schema/ConfirmationDialogStore';

export const getStore: () => ConfirmationDialogStoreState =
    createStore<ConfirmationDialogStoreState>('confirmationDialogStore', {
        isOpen: false,
    });
